{
  "title": "OMAD G'ILDIRAGI",
  "description": "Har kuni omadingni sina!",
  "available": "Bugungi bepul imkoniyat tayyor!",
  "spin": "🎡 AYLLANTIRISH",
  "spinning": "G'ildirak aylanmoqda...",
  "winTitle": "Tabriklaymiz!",
  "win": "Siz {{amount}} AZN bonus yutdingiz!",
  "used": "🎁 Bugungi imkoniyatdan foydalandingiz! Ertaga qaytib keling!",
  "homeCta": "G'ildirakka bosing va omadingizni sinab ko'ring",
  "homeUsed": "Ertaga qaytib keling!",
  "ribbonReady": "OMADINGNI SINA",
  "ribbonUsed": "ERTAGA QAYT",
  "hubSpin": "AYLANTIR",
  "sheetHint": "G'ildirakka bosing va omadingizni sinab ko'ring",
  "winAmount": "{{amount}} AZN YUTDINGIZ!",
  "closeResult": "Yopish",
  "demoBadge": "Vizual namoyish — haqiqiy bonus hozircha faol emas",
  "demoWinNote": "Bu faqat vizual natija. Bonus balansiga kredit qilinmadi.",
  "testBadge": "SAYT TESTI — TEST BONUS, yechib olinmaydi",
  "testWinNote": "{{amount}} AZN TEST BONUS kredit qilindi. Bu mablag' yechib olinmaydi va haqiqiy balansga qo'shilmaydi.",
  "testBalance": "Test bonus",
  "testLedger": "TEST BONUS (yechib olinmaydi)",
  "testNotWithdrawable": "Test mablag'ini yechib olish mumkin emas",
  "testExpires": "Test muddati: {{when}}",
  "testPrize": "Test mukofot: {{amount}} AZN",
  "mute": "Ovozni o'chirish",
  "unmute": "Ovozni yoqish",
  "close": "Yopish",
  "openAria": "VBB omad g'ildiragini ochish",
  "spinFailed": "Aylantirish boshlanmadi. Birozdan so'ng qayta urinib ko'ring.",
  "wageringTitle": "Bonus tikish talabi",
  "bonusBalance": "Bonus balansi",
  "wageringMultiplier": "Talab",
  "wageringMultiplierValue": "{{count}}x",
  "wageringTarget": "Tikish maqsadi",
  "wageringCompleted": "Bajarildi",
  "wageringRemaining": "Qoldi",
  "bonusStatus": "Bonus holati",
  "withdrawalEligibility": "Yechib olish",
  "bonusNotWithdrawable": "Bonus konvertatsiya tasdiqlanmaguncha yechib olinmaydi",
  "loginRequiredBadge": "Login required for real bonus",
  "loginRequired": "Please sign in."
}
